/** @jsxRuntime classic */
/** @jsx jsx */
import cx from 'classnames';
import { jsx } from '@emotion/react';

interface CloseIconProps extends React.HTMLProps<HTMLElement> {
  top?: string;
  right?: string;
  bottom?: string;
  left?: string;
}

function CloseIcon({
  className,
  top = '2.5',
  right = '5',
  bottom = '',
  left = '',
  ...props
}: CloseIconProps) {
  const classNames = [
    'fal fa-times',
    'absolute text-xl text-neutral-400 cursor-pointer z-10',
    `top-${top} right-${right}`,
    {
      [`bottom-${bottom}`]: !!bottom,
      [`left-${left}`]: !!left,
    },
    className,
  ];

  return <i className={cx(classNames)} {...props} />;
}

export default CloseIcon;
